"use strict";

var _classCallCheck = require("/opt/build/repo/graphiclab/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/graphiclab/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FrameManager = void 0;

var FrameManager = /*#__PURE__*/function () {
  function FrameManager(container) {
    _classCallCheck(this, FrameManager);

    this.container = container;
  }

  _createClass(FrameManager, [{
    key: "nextFrame",
    value: function nextFrame(timestamp) {
      try {
        var container = this.container;

        if (container.lastFrameTime !== undefined && timestamp < container.lastFrameTime + 1000 / container.fpsLimit) {
          container.draw();
          return;
        }

        var deltaValue = timestamp - container.lastFrameTime;
        var delta = {
          value: deltaValue,
          factor: 60 * deltaValue / 1000
        };
        container.lastFrameTime = timestamp;
        container.particles.draw(delta);

        if (container.getAnimationStatus()) {
          container.draw();
        }
      } catch (e) {
        console.error("tsParticles error in animation loop", e);
      }
    }
  }]);

  return FrameManager;
}();

exports.FrameManager = FrameManager;